import { motion } from 'framer-motion';
import SidebarGalleryPage from '../Main/Sidebargallery';
import Myimage from "../../assets/Career&Guidence/tnp_banner.jpg"


const studentGuidelinesInfo = {
  intro: "Students appearing for Campus selection should follow the guidelines mentioned below:",
  guidelines: [
    "Students with 75% attendance will be allowed to appear in the Campus Drives/Internship interviews.",
    "There should not be any indisciplinary record of the Students attending the campus process.",
    "Students with 6.0 CGPA and above aggregate marks will be allowed to attend the selection process.",
    "All Students appearing for the campus placement including the volunteers, are supposed to dress up in formals (boys – full sleeve shirt, formal trousers & shoes; Girls – Formal dress only will be allowed), right from the beginning of PPT till end of entire selection process.",
    "Students are advised not to interact directly with the visiting company Executives as it might create confusion during the selection process.",
    "Strict discipline will be maintained during the placement activity. The placement cell would be very strict regarding all the policies. Anyone found disobeying them would be debarred from the placement and may lose the job.",
    "Student’s behavior in presence of the company executives, in particular, frames the image of the Institution. Students should conduct themselves properly and should not make any attempt to tarnish the image of the Institute, failing which the miscreants will have to face adverse consequences by the committee.",
    "The student coordinators will check the ID cards of the students before the drive.",
    "The departmental faculty coordinators along with company HR will invigilate the students during the written test.",
    "Students will not be allowed to carry any electronic gadgets (cell phones, programmable calculators) in the examination hall."
  ],
  documentsChecklist: [
    "College Identity Proof",
    "Alternate Identity Proof (Driving License, PAN card, Voter Id, Aadhar Card, Passport)",
    "Student CV (Curriculum Vitae)",
    "Caste Certificate",
    "Passport size Photograph (Minimum two)",
    "Mark sheets of 10th, 12th, and all semesters",
    "Certificates of Achievements",
    "Internship/Training Certificates",
    "Minor Project and Major Project reports"
  ]
};

export default function StudentGuidelinesSection() {
  return (
    <div className="min-h-screen bg-gray-100 p-12">
      <div className="flex flex-col lg:flex-row gap-10">

        {/* Main Content */}
        <motion.div 
          className="lg:col-span-2"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        >
          <img 
            src={Myimage}
            alt="Guidelines Banner" 
            className="w-full rounded-lg border-4 border-teal-500 p-2 mb-10"
          />

          {/* <hr className="mt-7 mb-2 border-t border-dotted border-gray-400" /> */}

          <div className="border-4 border-teal-500 p-2 rounded-lg">
              <h2 className="text-2xl font-bold mb-4 text-white bg-[#00BFA5] p-2 rounded-sm">
                Student Guidelines
              </h2>
              <p className="mb-4 p-2">{studentGuidelinesInfo.intro}</p>
              <ul className="list-decimal list-inside pl-4">
                {studentGuidelinesInfo.guidelines.map((guideline, index) => (
                  <li key={index} className="mb-4">{guideline}</li>
                ))}
              </ul>
          </div>

          {/* <hr className="mt-7 mb-2 border-t border-dotted border-gray-400" /> */}

          <div className='border-4 border-[#00BFA5] rounded-lg p-2 mt-10'>
              <h1 className='font-bold bg-[#00BFA5] text-white p-2 text-xl'>Documents Checklist</h1>
              <div className='p-4'>
              <ul className="list-disc list-inside pl-4">
                {studentGuidelinesInfo.documentsChecklist.map((document, index) => (
                  <li key={index} className="mb-1">{document}</li>
                ))}
              </ul>
            </div>
          </div>
        </motion.div>

        {/* Sidebar - Gallery */}
        
        <SidebarGalleryPage title="gallery"></SidebarGalleryPage>
        </div>
    </div>
  )
}
